import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import Navbar from "./Common/Navbar";
import "./App.css";
import Home from "./Components/Home";

function App() {
  const About = lazy(() => import("./Components/About"));
  const Classes = lazy(() => import("./Components/Classes"));
  const Events = lazy(() => import("./Components/Events"));
  const Eventsingle = lazy(() => import("./Components/Eventsingle"));
  const Schedule = lazy(() => import("./Components/Schedule"));
  const Blog = lazy(() => import("./Components/blog"));
  const Classesingle = lazy(() => import("./Components/class-single"));
  const Contact = lazy(() => import("./Components/contact"));
  const Post = lazy(() => import("./Components/post"));
  useEffect(() => {
    // Load Google Analytics
    const scriptGA = document.createElement("script");
    scriptGA.src = "https://www.googletagmanager.com/gtag/js?id=UA-180910402-1";
    scriptGA.async = true;
    document.body.appendChild(scriptGA);

    scriptGA.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "UA-180910402-1");

      // Define the specific location (St. Paul's Matriculation School)
      const specificLocation = {
        latitude: 12.9463585, // Latitude from the Google Maps link
        longitude: 79.1450350, // Longitude from the Google Maps link
        locationName: "Trinity School", // Optional: Add a name for the location , 
      };

      // Send the specific location data to Google Analytics
      gtag("event", "set_location", {
        latitude: specificLocation.latitude,
        longitude: specificLocation.longitude,
        location_name: specificLocation.locationName, // Optional: Send location name
      });

      console.log("Specific location sent to GA:", specificLocation);
    };
  }, []);

  return (
    <Suspense
      fallback={
        <div className="fallback-container">
          <div className="animated-logo">
            <img
              src="/assets/img/logo3.png"
              loading="lazy"
              alt="Loading..."
            />
          </div>
          <div className="loading-text">Loading, please wait...</div>
        </div>
      }
    >
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/class-single" element={<Classesingle />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/post" element={<Post />} />
            <Route path="/events" element={<Events />} />
            <Route path="/event-single" element={<Eventsingle />} />
            <Route path="/schedule" element={<Schedule />} />
          </Routes>
        </div>
      </Router>
    </Suspense>
  );
}

export default App;
